import React, { useEffect, useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';

const SocialProfiles = ({socialProfiles, setSocialProfiles, socialloading, setSocialLoading}) => {
    
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            // If socialProfiles is a string, parse it
            if (typeof socialProfiles === 'string') {
                const parsedProfiles = JSON.parse(socialProfiles);
                setSocialProfiles(parsedProfiles);
            }
            setSocialLoading(false);
        } catch (err) {
            console.error('Error parsing social profiles:', err);
            setError('Invalid social profiles data format');
        }
    }, [socialProfiles, setSocialProfiles]);

    const handleInputChange = (field, value) => {
        setSocialProfiles(prevProfiles => ({
            ...prevProfiles,
            [field]: value
        }));
    };

    if (socialloading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-yourdetails dc-tabsinfo">
                <div className="dc-tabscontenttitle">
                    <h3>Social profiles</h3>
                </div>
                <div className="dc-formtheme dc-userform social-profiles-wrap">
                    <fieldset>
                        <div className="form-group form-group-half  dc-inputwithicon wt-facebook">
                            <i className="dc-icon fab fa-facebook" style={{ color: "#3b5998", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[facebook]" 
                                className="form-control" 
                                value={socialProfiles?.facebook || ""}
                                onChange={(e) => handleInputChange('facebook', e.target.value)}
                                placeholder="Facebook Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-twitter">
                            <i className="dc-icon fab fa-twitter" style={{ color: "#55acee", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[twitter]" 
                                className="form-control" 
                                value={socialProfiles?.twitter || ""}
                                onChange={(e) => handleInputChange('twitter', e.target.value)}
                                placeholder="Twitter Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-linkedin">
                            <i className="dc-icon fab fa-linkedin" style={{ color: "#0177b5", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[linkedin]" 
                                className="form-control" 
                                value={socialProfiles?.linkedin || ""}
                                onChange={(e) => handleInputChange('linkedin', e.target.value)}
                                placeholder="Linkedin Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-skype">
                            <i className="dc-icon fab fa-skype" style={{ color: "#00aff0", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[skype]" 
                                className="form-control" 
                                value={socialProfiles?.skype || ""}
                                onChange={(e) => handleInputChange('skype', e.target.value)}
                                placeholder="Skype ID" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-pinterestp">
                            <i className="dc-icon fab fa-pinterest-p" style={{ color: "#bd081c", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[pinterest]" 
                                className="form-control" 
                                value={socialProfiles?.pinterest || ""}
                                onChange={(e) => handleInputChange('pinterest', e.target.value)}
                                placeholder="Pinterest Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-tumblr">
                            <i className="dc-icon fab fa-tumblr" style={{ color: "#36465d", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[tumblr]" 
                                className="form-control" 
                                value={socialProfiles?.tumblr || ""}
                                onChange={(e) => handleInputChange('tumblr', e.target.value)}
                                placeholder="Tumblr Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-instagram">
                            <i className="dc-icon fab fa-instagram" style={{ color: "#c53081", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[instagram]" 
                                className="form-control" 
                                value={socialProfiles?.instagram || ""}
                                onChange={(e) => handleInputChange('instagram', e.target.value)}
                                placeholder="Instagram Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-flickr">
                            <i className="dc-icon fab fa-flickr" style={{ color: "#ff0084", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[flickr]" 
                                className="form-control" 
                                value={socialProfiles?.flickr || ""}
                                onChange={(e) => handleInputChange('flickr', e.target.value)}
                                placeholder="Flickr Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-medium">
                            <i className="dc-icon fab fa-medium" style={{ color: "#02b875", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[medium]" 
                                className="form-control" 
                                value={socialProfiles?.medium || ""}
                                onChange={(e) => handleInputChange('medium', e.target.value)}
                                placeholder="Medium Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-tripadvisor">
                            <i className="dc-icon fab fa-tripadvisor" style={{ color: "#FF0000", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[tripadvisor]" 
                                className="form-control" 
                                value={socialProfiles?.tripadvisor || ""}
                                onChange={(e) => handleInputChange('tripadvisor', e.target.value)}
                                placeholder="Tripadvisor Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-wikipedia">
                            <i className="dc-icon fab fa-wikipedia-w" style={{ color: "#5a5b5c", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[wikipedia]" 
                                className="form-control" 
                                value={socialProfiles?.wikipedia || ""}
                                onChange={(e) => handleInputChange('wikipedia', e.target.value)}
                                placeholder="Wikipedia Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-vimeo">
                            <i className="dc-icon fab fa-vimeo-square" style={{ color: "#00adef", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[vimeo]" 
                                className="form-control" 
                                value={socialProfiles?.vimeo || ""}
                                onChange={(e) => handleInputChange('vimeo', e.target.value)}
                                placeholder="Vimeo Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-youtube">
                            <i className="dc-icon fab fa-youtube" style={{ color: "#cd201f", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[youtube]" 
                                className="form-control" 
                                value={socialProfiles?.youtube || ""}
                                onChange={(e) => handleInputChange('youtube', e.target.value)}
                                placeholder="Youtube Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-whatsapp">
                            <i className="dc-icon fab fa-whatsapp" style={{ color: "#0dc143", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[whatsapp]" 
                                className="form-control" 
                                value={socialProfiles?.whatsapp || ""}
                                onChange={(e) => handleInputChange('whatsapp', e.target.value)}
                                placeholder="Whatsapp Number" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-vkontakte">
                            <i className="dc-icon fab fa-vk" style={{ color: "#5A80A7", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[vkontakte]" 
                                className="form-control" 
                                value={socialProfiles?.vkontakte || ""}
                                onChange={(e) => handleInputChange('vkontakte', e.target.value)}
                                placeholder="Vkontakte Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-odnoklassniki">
                            <i className="dc-icon fab fa-odnoklassniki" style={{ color: "#f58220", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[odnoklassniki]" 
                                className="form-control" 
                                value={socialProfiles?.odnoklassniki || ""}
                                onChange={(e) => handleInputChange('odnoklassniki', e.target.value)}
                                placeholder="Odnoklassniki Link" 
                            />
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    );
};

export default SocialProfiles;
